import React, {useCallback, useLayoutEffect, useState} from 'react'
import styled from 'styled-components'
import {ImageProps} from './ImageProps'

const StyledImg = styled.img`
  overflow: hidden;
  font-size: 0;
  object-fit: cover;
`

export default function Image({src: base, ...props}: ImageProps) {
  const [src, setSrc] = useState(typeof base === 'string' ? base : undefined)

  const handleLoadFile = useCallback(() => {
    if (typeof base === 'object') {
      const objectURL = URL.createObjectURL(base)

      setSrc(objectURL)
      return
    }

    setSrc(base)
  }, [base])

  const handleRevoke = useCallback(() => {
    if (!src?.startsWith('blob:')) return

    URL.revokeObjectURL(src)
  }, [src])

  useLayoutEffect(handleLoadFile, [handleLoadFile])

  return (
    <StyledImg
      {...props}
      src={src}
      onLoad={handleRevoke}
      onAbort={handleRevoke}
      onError={handleRevoke}
    />
  )
}
